import CheckoutAddress from './CheckoutAddress';

export default CheckoutAddress;


// WEBPACK FOOTER //
// ./src/components/CheckoutAddress/index.jsx